export async function handleDownloadImage(
  imageName?: string,
): Promise<File | undefined> {
  let image: File | undefined;

  if (imageName) {
    const file = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/files/${imageName}`,
    );

    const blobFile = await file.blob();

    image = new File([blobFile], imageName.split('-')[1]);
  }

  return image;
}
